import { render, staticRenderFns } from "./Calculo.vue?vue&type=template&id=37fda43f&"
import script from "./Calculo.vue?vue&type=script&lang=js&"
export * from "./Calculo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports